<template>
  <BasicLayout :left="left" :middle="middle" :right="right">
    <template v-slot:right_view>
      <div class="h-toolbarBg">
        <ejs-toolbar :items="toolbarItems"></ejs-toolbar>
        <!-- <div class='h-inputBox'>
          <ejs-textbox v-model='keyword' :placeholder='$t("Monitor.task.taskName")' @keyup.enter.native="filterMonitorTask" maxLength='20'></ejs-textbox>
        </div> -->
      </div>
      <div class="h100-80 h-scroll">
        <ejs-grid :dataSource="measureCustomData" :allowPaging="true" ref="grid" :pageSettings="pageSettings" :height="screenHeight" :allowResizing='true' >
          <e-columns>
            <e-column field="customCounterTypeId" :headerText="$t('Pm.customCounterTypeId')" width="120" textAlign="Center"></e-column>
            <e-column field="customCounterTypeName" :headerText="$t('Pm.customCounterTypeName')" width="120" textAlign="Center"></e-column>
            <e-column field="createTime" :headerText="$t('Security.Role.createTime')" :format="dateFormat" width="120" textAlign="Center" clipMode="EllipsisWithTooltip"></e-column>
          </e-columns>
        </ejs-grid>
        <ejs-pager
          ref="pager"
          :pageSize="pageSettings.pageSize"
          :pageCount="page.pageCount"
          :currentPage="page.pageNo"
          :totalRecordsCount="page.totalRecordsCount"
          @click="getMeasureCustomList"
        ></ejs-pager>
      </div>
      <CustomDialog
        ref="addMeasureCustomDialog"
        v-bind:element="addDialog.element"
        v-bind:styles="addDialog.styles">
        <template v-slot:dialog-content>
          <AddMeasureCustom ref="addMeasureCustomPage"></AddMeasureCustom>
        </template>
      </CustomDialog>

      <CustomDialog
        ref="showMeasureCustomDialog"
        v-bind:element="showDialog.element"
        v-bind:styles="showDialog.styles">
        <template v-slot:dialog-content>
          <ShowMeasureCustom ref="showMeasureCustomPage"></ShowMeasureCustom>
        </template>
      </CustomDialog>
      </template>
  </BasicLayout>
</template>
<script>
import BasicLayout from '../../../layouts/BasicLayout';
import CustomDialog from '../../../components/common/CustomDialog';
import AddMeasureCustom from '../../../components/pmConfig/4gproject/measureCustom/AddMeasureCustom';
import ShowMeasureCustom from '../../../components/pmConfig/4gproject/measureCustom/ShowMeasureCustom';
import { EventBus } from "../../../plugins/eventBus";
import { Resize} from "@syncfusion/ej2-vue-grids";
export default {
  name: 'MeasureCustom',
  components: {
    CustomDialog,
    BasicLayout,
    AddMeasureCustom,
    ShowMeasureCustom,
  },
   provide: {
      grid: [ Resize]
    },
  data() {
    return {
      measureCustomData: [],
      left: { show: false, name: '' },
      middle: { show: false, name: '' },
      right: { show: true, crumb: `${this.$t('Pm.pmManagement')}`+'/' + `${this.$t('Pm.cycleMeasurement')}` + '/' + `${this.$t('Pm.measureCustom')}` },
      toolbarItems: [
        { prefixIcon: 'icon hero-icon hero-icon-add', tooltipText: this.$t('Security.add'), click: this.showAddDialog },
        { prefixIcon: 'icon hero-icon hero-icon-details', tooltipText: this.$t('Pm.showMeasureCustom'), click: this.showModifyDialog },
        { prefixIcon: 'icon hero-icon hero-icon-remove', tooltipText: this.$t('Security.delete'), click: this.deleteMeasureCustom },
        { prefixIcon: 'icon hero-icon hero-icon-refresh', tooltipText: this.$t('Alarm.refresh'), click: this.refreshGrid },
      ],
      neTypeId: '101',
      pageSettings: { pageSize: 15 },
      page: {
        pageCount: 4,
        totalRecordsCount: 0,
        pageNo: 1,
      },
      dateFormat: {
        type: 'date', format: 'yyyy/MM/dd HH:mm:ss'
      },
      editId: '',
      addDialog: {
        element: {
          target: '#app',
          isClose: true,
          refName: 'addMeasureCustomDialog',
          buttonGroup: [
            {
              click: this.dialogHide,
              buttonModel: { content: `${this.$t('Common.cancel')}` }
            },
            {
              click: this.addMeasureCustom,
              buttonModel: { content: `${this.$t('Common.ok')}`, cssClass: 'primary-btn' }
            }
          ],
          title: `${this.$t('Pm.addMeasureCustom')}`
        },
        styles: {
          width: '810px',
          height: '650px',
          model: true,
          visible: false
        }
      },
      showDialog: {
        element: {
          target: '#app',
          isClose: true,
          refName: 'showMeasureCustomDialog',
          buttonGroup: [
            {
              click: this.dialogHide,
              buttonModel: { content: `${this.$t('Common.close')}` }
            },
          ],
          title: `${this.$t('Pm.showMeasureCustom')}`
        },
        styles: {
          width: '810px',
          height: '650px',
          model: true,
          visible: false
        }
      },
      screenHeight: document.body.clientHeight - 240
    };
  },
  mounted() {
    this.getMeasureCustomList();
    let That = this;
    window.onresize = () => {
      return (() => {
        That.screenHeight = document.body.clientHeight - 240;
      })()
    }
  },
  methods: {
    getMeasureCustomList() {
      const url = '/lte/pm/measureCustom/selectMeasure';
      this.page.pageNo = this.$refs.pager.ej2Instances.currentPage;
      const params = { params: {
        pageNo: this.page.pageNo,
        pageSize: this.page.pageSize
      } };
      const That = this;
      this.axios.get(url, params).then(response => {
        const result = response.data.result;
        if(result !== undefined && result.length >0){
          result.forEach((v) => {
            let date = new Date();
            if (!!v.createTime) {
              date.setTime(v.createTime);
              v.createTime = date;
            }
          });
        }
        That.measureCustomData = result;
        That.page.totalRecordsCount = response.data.totalCount;
      });
    },
    getRecord() {
      const result = this.$refs.grid.getSelectedRecords();
      if (result === null || result === '') {
        this.$parent.showToast('warning',`${this.$t('Common.tips.noSelect')}`);
        return null;
      }
      return result;
    },
    showAddDialog() {
      this.$refs.addMeasureCustomPage.init(this.neTypeId);
      this.$refs.addMeasureCustomDialog.show();
    },
    showModifyDialog() {
      const record = this.getRecord();
      if (record.length === 0) {
        this.$parent.showToast('warning',`${this.$t('Common.tips.selectOne')}`);
        return null;
      }
      if (record.length !== 1) {
        this.$parent.showToast('warning',`${this.$t('Common.tips.onlyOneSelect')}`);
        return null;
      }
      const _measureObjectTypeCode = record[0].customCounterTypeId;
      this.$refs.showMeasureCustomPage.findCounter(this.neTypeId, _measureObjectTypeCode);
      this.$refs.showMeasureCustomDialog.show();
    },
    deleteMeasureCustom() {
      const record = this.getRecord();
      if (record.length === 0) {
        this.$parent.showToast('warning',`${this.$t('Common.tips.selectOne')}`);
        return null;
      }
      const url = '/lte/pm/measureCustom/deleteMeasure';
      const params = [];
      record.forEach((r, i) => {
        params.push(r.customCounterTypeId);
      });
      const That = this;
       That.axios.post('/lte/pm/measureCustom/selectCostomMeasureByNoRealTimeTask', params).then(response => {
         if (response.data) {
           if (response.data.msg && response.data.msg.length > 0) {
             const taskName = [];
             for (let i = 0; i < response.data.msg.length; i++) {
               taskName.push(response.data.msg[i].sysMeterTaskName);
             }

             That.$parent.showToast('error', `${this.$t('Pm.check_customMeasureId_tips')}【${taskName.join(',')}】`);
           } else {
             That.$layer.confirm({
               msg: `${this.$t('Common.tips.confirmTip')}`,
               btn1: {
                 msg: `${this.$t('Common.cancel')}`
               },
               btn2: {
                 msg: `${this.$t('Common.ok')}`,
                 func: () => {
                   That.axios.post(url, params).then(response => {
                     if (response.data) {
                       That.$parent.showToast('success', `${this.$t('Common.tips.success')}`);
                       That.getMeasureCustomList();
                     } else {
                       That.$parent.showToast('error', `${this.$t('Common.tips.failure')}`);
                     }
                   });
                 }
               }
             });
           }
         }
       });
    },
    addMeasureCustom() {
      let status = this.$refs.addMeasureCustomPage.validation();
      if(!status){
        return;
      }
      const url = '/lte/pm/measureCustom/insertMeasure';
      const measureCustomInfo = this.$refs.addMeasureCustomPage.getMeasureCustomInfo();
      if(measureCustomInfo == null) {
        return;
      }
      let That = this;
      this.axios.post(url, measureCustomInfo).then(res => {
        if(!!res.data && res.data.success==0){
          That.eventEmit('success',res.data.msg);
          That.getMeasureCustomList();
          That.dialogHide();
        }else{
          That.eventEmit('error',`${That.$t('Common.tips.failure')}`+':'+res.data.msg);
        }
      });
    },
    dialogHide() {
      this.$refs.addMeasureCustomDialog.clear();
      this.$refs.addMeasureCustomDialog.close();
      this.$refs.showMeasureCustomDialog.clear();
      this.$refs.showMeasureCustomDialog.close();
    },
    refreshGrid() {
      this.getMeasureCustomList();
    },
    getCheckedData(selectOnly) {
      // false: 不支持多选   true: 支持多选
      const selectedRecords = this.$refs.grid.getSelectedRecords();
      if (selectedRecords.length < 1) {
        // EventBus.$emit('toast', {type: 'warning', content: this.$t('Alarm.no_checked')});
        this.$parent.showToast('warning',`${this.$t('Alarm.no_checked')}`);

        return false;
      }
      if (selectedRecords.length > 1 && !selectOnly) {
        // EventBus.$emit('toast', {type: 'warning', content: this.$t('Common.tips.onlyOneSelect')});
        this.$parent.showToast('warning',`${this.$t('Common.tips.onlyOneSelect')}`);
        return false;
      }
      return selectedRecords;
    },
    eventEmit(type, content) {
      EventBus.$emit('toast', {type: type, content: content})
    }
  }
}
</script>
